module.exports = __webpack_public_path__ + "static/media/user-profile.616fcc9d.png";